/**
 * Router-scoped sibling of `ReunificationJoinPromptProvider` — renders
 * the modal for the head of the prompt queue and owns the
 * `useNavigate()` dependency so the provider can sit above BrowserRouter
 * (which in turn lets `SocketMessageRouter` pull `enqueueJoinPrompt`
 * from context and thread it into HandlerDeps).
 */

import { useNavigate } from 'react-router-dom';
import { useReunificationJoinPrompt } from '../../contexts/ReunificationJoinPromptContext';
import { ReunificationJoinPromptDialog } from './ReunificationJoinPromptDialog';

export function ReunificationJoinPromptUI() {
  const navigate = useNavigate();
  const { headPrompt, dismissHead, joinHead } = useReunificationJoinPrompt();

  const handleJoin = () => {
    const path = joinHead();
    if (path) navigate(path);
  };

  return (
    <ReunificationJoinPromptDialog
      payload={headPrompt}
      onJoin={handleJoin}
      onDismiss={dismissHead}
    />
  );
}
